'use strict';

class SalesLedgerEntries {
  constructor(salesLedgerService) {
    this.salesLedgerService = salesLedgerService;
  }

  $onInit() {
    this.entries = [];
    this.total = 0;

    //this caused double load by onInit and onChanges
    // this.load();
  }

  $onChanges() {
    this.load();
  }

  sum(items) {
    let total = 0;

    items.forEach((item) => {
      total += item.amount;
    });

    return total;
  }

  load() {
    if (this.number) {
      this.salesLedgerService.getInvoiceEntries(this.number)
        .then((resp) => {
          // console.log('      ##### SLE get entries #####');
          if (resp && resp.data) {
            this.entries = resp.data.sort((a, b) => new Date(b.date) - new Date(a.date)).reverse();
            this.total = this.sum(resp.data);
          }
        });
    }
  }

  confirm(number) {
    swal({
      title: 'Bekreft kansellering av purregebyr',
      showCancelButton: true,
      confirmButtonColor: '#c60f13',
      confirmButtonText: 'Ja',
      cancelButtonText: 'Nei',
      closeOnConfirm: true
    }, () => {
      this.salesLedgerService.cancelPayment(number)
        .then(() => this.load());
    });
  }
}

SalesLedgerEntries.$inject = ['salesLedgerService'];

const salesledgerEntries = {
  bindings: {
    number: '<'
  },
  controller: SalesLedgerEntries,
  template: `
    <table class="small" ng-show="$ctrl.entries.length > 1" >
      <thead>
        <tr>
          <th>Dato</th>
          <th>Type</th>
          <th>Krav</th>
          <th>Innbetalinger</th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="entry in $ctrl.entries track by $index">
          <td>{{ entry.date | dateFormat }}</td>
          <td>
            {{ entry.description }}
            <a ng-if="entry.description === 'Kreditnota'" href="#/kreditnota/{{ entry._links.creditNote.uri | urlParser:2 }}"><i class="fa fa-external-link" style="font-size: 0.8em;"></i></a>
            <a ng-if="entry.description === 'Purregebyr'" href="#/purring/{{ entry._links.dunning.uri | urlParser:1 }}"><i class="fa fa-external-link" style="font-size: 0.8em;"></i></a>
          </td>
          <td class="debit">
            <span ng-show="entry.amount > 0">{{ entry.amount | crowns }}</span>
          </td>
          <td class="credit">
            <span ng-show="entry.amount < 0">{{ entry.amount * -1 | crowns }}</span>
          </td>
          <td class="right-align">
            <a ng-if="entry.description !== 'Purregebyr' && (entry._links.edit || entry._links.cancel || entry._links.refund)" href="#/regning/{{ $ctrl.number }}/betaling/{{ entry.number }}" role="button" class="button small info"><i class="fa fa-pencil"></i> Korriger</a>
            <a ng-if="entry.description === 'Purregebyr' && entry._links.cancel" href ng-click="$ctrl.confirm(entry.number)" role="button" class="button small info"><i class="fa fa-times"></i> Fjern</a>
            <a ng-if="entry._links.loss" href="#/regning/{{ $ctrl.number }}/renter/{{ entry.number }}" role="button" class="button small info"><i class="fa fa-edit"></i> Korriger</a>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="5" class="center-align">
            Saldo for denne regningen: {{ $ctrl.total | crowns }}
          </th>
        </tr>
      </tfoot>
    </table>
  `
};

angular
  .module('SendRegning')
  .component('salesledgerEntries', salesledgerEntries);
